import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import useRouteName from "./useRouteName.js";
import useProfiler from "./useProfiler.js";
import useVirutalInterlining from "./useVirutalInterlining.js";
import { getFlightDetailsSlice } from "../store/flightDetails/selectors.js";
import { stage } from "@flights/et-universal";
export default function useTrackViAA() {
    const routeName = useRouteName();
    const { isDirect } = useProfiler();
    const { isVirtualInterliningFlight } = useVirutalInterlining();
    const flightDetails = useSelector(getFlightDetailsSlice);
    const experiment = "flights_web_aa_virtual_interlining_tracking";
    const flight = flightDetails?.flight;
    const isCabinIncluded = useMemo(() => !!flight?.includedProducts?.segments?.some((p) => p.some((_) => _.luggageType === "HAND")), [flight]);
    const isCabinAvailable = useMemo(() => flight?.ancillaries?.cabinBaggagePerTraveller?.luggageAllowance?.luggageType === "HAND", [flight]);
    const ViAAInStage1 = useCallback(() => {
        if (!isDirect())
            return;
        if (routeName !== "searchresults")
            return;
        stage(experiment, 1);
    }, [isDirect, routeName]);
    const ViAAInStage2 = useCallback((_f) => {
        if (!isDirect() || !_f)
            return;
        if (!isVirtualInterliningFlight(_f?.segments || []))
            return;
        stage(experiment, 2);
    }, [isDirect, isVirtualInterliningFlight]);
    const ViAAInStage3 = useCallback((_f) => {
        if (!isDirect() || !_f)
            return;
        if (!isVirtualInterliningFlight(_f?.segments || []))
            return;
        stage(experiment, 3);
    }, [isDirect, isVirtualInterliningFlight]);
    const ViAAInStage4 = useCallback((_f) => {
        if (!isDirect() || !_f)
            return;
        if (isVirtualInterliningFlight(_f?.segments || []))
            return;
        stage(experiment, 4);
    }, [isDirect, isVirtualInterliningFlight]);
    const ViAAInStage5 = useCallback(() => {
        if (!isDirect() || !flight)
            return;
        if (routeName !== "checkout-extras")
            return;
        if (!isVirtualInterliningFlight(flight?.segments || []))
            return;
        stage(experiment, 5);
    }, [isDirect, isVirtualInterliningFlight, routeName, flight]);
    const ViAAInStage6 = useCallback(() => {
        if (!isDirect() || !flight)
            return;
        if (routeName !== "checkout-extras")
            return;
        if (isVirtualInterliningFlight(flight?.segments || []))
            return;
        stage(experiment, 6);
    }, [isDirect, isVirtualInterliningFlight, routeName, flight]);
    const ViAAInStage7 = useCallback(() => {
        if (!isDirect() || !flight)
            return;
        if (routeName !== "checkout-extras")
            return;
        if (!isVirtualInterliningFlight(flight?.segments || []))
            return;
        if (isCabinIncluded || isCabinAvailable)
            return;
        stage(experiment, 7);
    }, [isDirect, isVirtualInterliningFlight, routeName, flight, isCabinIncluded, isCabinAvailable]);
    return {
        ViAAInStage1,
        ViAAInStage2,
        ViAAInStage3,
        ViAAInStage4,
        ViAAInStage5,
        ViAAInStage6,
        ViAAInStage7
    };
}
